export const pannelloDiControllo = 
{
  "label": "Pannello di Controllo",
  "labelDisable": false,
  "children": [
    {
      "name": "Questionari",
      "to": "/app",
      "exact": true,
      "active": true
    },
    {
      "name": "Per creare un nuovo questionario",
      "to": "/app/info/partner-per-iniziare",
      "exact": true,
      "active": true
    }
  ]
}
